<template>
  <div id="tagList" class="h-full">
    <!-- 位号编辑新增操作框 -->
    <HandoverFormDialog
      v-if="handoverFormProps.dialogVisible"
      :handoverFormProps="handoverFormProps"
      @handoverFormEmit="handoverFormEmit"
    />
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <div class="flex">
        <selectStandardId
          :selectStandardProps="{ width: 'w-360px' }"
          @updateStandardId="updateStandardId"
        />
        <el-input
          size="small"
          class="w-400px mx-10px"
          :placeholder="`${$t('pleaseEnterCodeOrName')}`"
          v-model.trim="mainTableParam.keyword"
          @keyup.native.enter="searchList()"
          data-cy="inputSearch"
          clearable
        ></el-input>
        <!-- <el-select
            v-model="tagSearchNameList"
            :placeholder="`${$t('SearchForAssetCategories')}`"
            class="!w-500px mr-10px"
            size="small"
            multiple
            clearable
            filterable
            :filter-method="getParentTypeList"
            collapse-tags
            popper-class="tag_select-popper"
            ref="tagSearchSelect"
            @remove-tag="removeTagSearchTag"
            @clear="clearTagSearchTag"
          >
            <el-option :label="tagSearchName" :value="searchTagClassIds">
              <el-tree
                :data="tagTreeData"
                :props="classTreeProps"
                node-key="id"
                @node-click="handleSearchTagTreeClick"
                :expand-on-click-node="false"
              >
                <div
                  slot-scope="{ node, data }"
                  class="text-14px h-full tree-node"
                  style="line-height: 24px; width: calc(100% - 40px)"
                >
                  <span :class="{ 'text-blue': searchTagClassIds.includes(data.id) }">
                    {{ data.code }}({{ node.label }})
                  </span>
                  <i
                    v-if="searchTagClassIds.includes(data.id)"
                    class="el-icon-check text-blue font-bold"
                  ></i>
                </div>
              </el-tree>
            </el-option>
          </el-select> -->
        <el-button type="primary" @click="getDynamicTableResult('search')">{{
          $t('search')
        }}</el-button>
        <el-button type="primary" @click="toMoreSearch">高级查询</el-button>
        <el-button
          :disabled="!$hasAccess('create')"
          type="primary"
          @click="openTagListDialog(null)"
          >{{ $t('new') }}</el-button
        >
        <el-button
          :disabled="!$hasAccess('delete')"
          type="danger"
          @click="deleteDynamicData(totalSelection)"
          >{{ $t('delete') }}</el-button
        >
        <el-button :disabled="!$hasAccess('export')" @click="exportExcel" :loading="exportLoading">
          {{ $t('export') }}
        </el-button>
        <el-button :disabled="!$hasAccess('import')" @click="importFile">
          {{ $t('import') }}
        </el-button>
        <el-button @click="toDownloadQrCode">二维码</el-button>
        <!-- <columnVisible
            :options="columnVisibleOptions"
            class="dib ml-10px"
            :name="['handoverTag']"
            :defaultValue="columnVisible"
            @columnVisibleChanged="handleColumnVisibleChanged"
          ></columnVisible> -->
      </div>
      <el-row :gutter="20" class="h-full">
        <el-col
          :span="6"
          class="h-[calc(100%-56px)] border-1px mt-20px relative"
          v-show="isShowTreeMode"
        >
          <div class="border-l-3 border-color-primary my-20px pl-10px text-16px">实体列表</div>
          <el-tabs
            v-model="activeTab"
            class="mb-10px h-[calc(100%-70px)] class-tree-tabs"
            @tab-click="handleTabChange"
          >
            <!-- 类别树 -->
            <el-tab-pane class="h-full" label="类别树" name="category" v-loading="treeLoading">
              <div class="mb-10px flex">
                <el-input
                  size="small"
                  class="mr-10px"
                  v-model="classKeyword"
                  :placeholder="`${$t('pleaseEnterCodeOrName')}`"
                  clearable
                ></el-input>
                <el-button type="primary" @click="getParentTypeList">{{ $t('search') }}</el-button>
              </div>
              <div class="w-full h-[calc(100%-96px)] overflow-y-auto">
                <el-tree
                  :data="tagTreeData"
                  :props="classTreeProps"
                  node-key="id"
                  @node-click="handleSearchTagTreeClick"
                  :expand-on-click-node="false"
                  :highlight-current="true"
                >
                  <div
                    slot-scope="{ node, data }"
                    class="w-[calc(100%-40px)] text-overflow relative"
                  >
                    <el-tooltip
                      :content="`${data.code}（ ${node.label} ）`"
                      placement="top"
                      :disabled="isShowTooltip"
                    >
                      <span
                        class="text-overflow mt-2px"
                        :class="`treeTooltip${data.id}`"
                        @mousemove="classTreeMouseOver(`treeTooltip${data.id}`)"
                      >
                        <span>{{ data.code }}({{ node.label }})</span>
                      </span>
                    </el-tooltip>
                  </div>
                </el-tree>
              </div>
            </el-tab-pane>
            <!-- 上下级树 -->
            <el-tab-pane class="h-full" label="上下级" name="hierarchy" v-loading="treeLoading">
              <div class="mb-10px flex">
                <el-input
                  size="small"
                  class="mr-10px"
                  v-model="hierarchyKeyword"
                  :placeholder="`${$t('pleaseEnterCodeOrName')}`"
                  clearable
                ></el-input>
                <el-button type="primary" @click="getHierarchyList">{{ $t('search') }}</el-button>
              </div>
              <div class="w-full h-[calc(100%-96px)]">
                <vue-easy-tree
                  :data="hierarchyTreeData"
                  :props="hierarchyTreeProps"
                  node-key="id"
                  @node-click="handleHierarchyTreeClick"
                  :highlight-current="true"
                  lazy
                  :load="loadHierarchyNode"
                  height="100%"
                  class="h-full"
                >
                  <div
                    slot-scope="{ node, data }"
                    class="w-[calc(100%-40px)] text-overflow relative"
                  >
                    <el-tooltip
                      :content="`${node.label}`"
                      placement="top"
                      :disabled="isShowTooltip"
                    >
                      <span
                        class="text-overflow mt-2px"
                        :class="`treeTooltip${data.id}`"
                        @mousemove="classTreeMouseOver(`treeTooltip${data.id}`)"
                      >
                        <span>{{ node.label }}</span>
                      </span>
                    </el-tooltip>
                  </div>
                </vue-easy-tree>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div
            v-if="isShowTreeMode"
            class="absolute right-0 top-1/2 cursor-pointer"
            @click="changeTreeMode"
          >
            <i class="iconfont icon-bg-circleLeft text-24px"></i>
          </div>
        </el-col>
        <el-col :span="isShowTreeMode ? 18 : 24" class="h-full relative">
          <div
            class="absolute left-[-10px] top-1/2 cursor-pointer z-999"
            v-if="!isShowTreeMode"
            @click="changeTreeMode"
          >
            <i class="iconfont icon-bg-circleRight text-24px"></i>
          </div>
          <!--header  begin-->
          <el-row :gutter="10" type="flex" align="middle"> </el-row>
          <!--header  end-->
          <!--table  begin-->
          <el-row type="flex" :gutter="20" class="mt-20px" style="height: calc(100% - 104px)">
            <el-col :span="24" class="h-full">
              <div style="height: 100%">
                <el-table
                  border
                  v-loading="tagListLoading"
                  :data="tagListTable"
                  @sort-change="sortChange"
                  @selection-change="getIdArray"
                  @row-dblclick="openTagListDialog"
                  ref="multipleTable"
                  height="100%"
                  stripe
                  data-cy="tagListTable"
                  row-key="id"
                >
                  <el-table-column
                    v-if="tableHeader.length > 0"
                    fixed
                    :reserve-selection="true"
                    type="selection"
                    width="40"
                  ></el-table-column>
                  <el-table-column
                    v-if="tableHeader.length > 0"
                    type="index"
                    :label="`${$t('seqNo')}`"
                    width="70"
                  >
                  </el-table-column>
                  <el-table-column
                    v-for="(val, index) in tableHeader"
                    :key="index"
                    :prop="`${val.tableName}.${val.columnName}`"
                    :sortable="val.name === '类别' ? false : true"
                    :label="val.name"
                    show-overflow-tooltip
                    min-width="150"
                  >
                    <template slot-scope="scope">
                      {{ scope.row[`${val.tableName}.${val.columnName}`] }}
                      <span v-if="val.unit">{{ val.unit }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="`${$t('operate')}`"
                    key="edit"
                    width="250"
                    fixed="right"
                    v-if="tableHeader.length > 0"
                  >
                    <template slot-scope="scope">
                      <el-button
                        :disabled="!$hasAccess('read')"
                        size="mini"
                        @click="linkTagContent(scope.row)"
                        >{{ $t('BrowsingPosition') }}</el-button
                      >
                      <el-button
                        :disabled="!$hasAccess('update')"
                        size="mini"
                        @click="openTagListDialog(scope.row)"
                        >{{ $t('edit') }}</el-button
                      >
                      <el-button
                        :disabled="!$hasAccess('delete')"
                        size="mini"
                        @click="deleteDynamicData([scope.row])"
                        >{{ $t('delete') }}</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
          <!--table  end-->
          <!--pagination  begin-->
          <el-pagination
            background
            @size-change="getDynamicTableResult('search')"
            @current-change="getDynamicTableResult"
            :current-page.sync="mainTableParam.pageno"
            :page-size.sync="mainTableParam.pagesize"
            :page-sizes="$pageSizeAll"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            class="float-right mt-20px"
          ></el-pagination>
          <!--pagination  end-->
        </el-col>
      </el-row>
    </el-card>
    <!-- 高级查询 -->
    <advancedQueries
      :advancedQueriesProps="advancedQueriesProps"
      @updateAdvancedQueries="updateAdvancedQueries"
    ></advancedQueries>
    <!-- 上传 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="getDynamicTableResult('search')"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
    <!-- 二维码 -->
    <el-dialog
      v-if="qrCodeDialogVisible"
      :visible.sync="qrCodeDialogVisible"
      :title="qrCodeDialogTitle"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @close="closeQrCodeDialog"
      width="750px"
      top="30vh"
      v-dialogDrag
    >
      <!-- 设置二维码尺寸 -->
      <div v-if="showQrCodeSize">
        <span class="mr-20px">二维码尺寸(单位：px)</span>
        <el-input-number
          class="w-500px"
          :controls="false"
          v-model="qrCodeSize"
          :min="1"
          :max="1000"
          placeholder="请设置二维码宽度"
        ></el-input-number>
      </div>
      <div v-if="showQrCodeSize" slot="footer" class="dialog-footer">
        <el-button @click="closeQrCodeDialog">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="qrCodeSubmit">{{ $t('confirm') }}</el-button>
      </div>
      <!-- 二维码生成进度 -->
      <div v-if="!showQrCodeSize" class="my-20px">
        <p class="mb-10px">二维码生成进度：</p>
        <el-progress :percentage="qrCodePercent"></el-progress>
        <p class="mt-20px mb-10px">当前下载地址：</p>
        <div v-if="qrCodePercent === 100">
          <div>
            {{
              `${currentEnv.VUE_APP_STANDARD_SERVER}/api/std/Common/get-loacle-file/${qrCodeUrl}`
            }}
          </div>
          <el-button
            class="mt-10px"
            type="primary"
            :loading="downloadLoading"
            @click="downloadQrCode"
            >下载</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import TagService from '@/services/tags'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
import ApiMixinTags from '@/assets/js/api/tags'
// import columnVisible from '@/components/ColumnVisible'
import fnMixin from '@/assets/js/fnMixins'
import ApiMixinCable from '@/assets/js/api/cableManagement'
import DocumentManagementService from '@/services/documentManagement'
import stdClassListService from '@/services/stdClassListService'
import vueEasyTree from '@wchbrad/vue-easy-tree'
import '@wchbrad/vue-easy-tree/src/assets/index.scss'
import selectStandardId from '../../components/selectStandardId'
import HandoverFormDialog from '../../components/handoverFormDialog'
import advancedQueries from '../../components/advancedQueries'

export default {
  name: 'handoverTag',
  components: {
    // columnVisible,
    selectStandardId,
    HandoverFormDialog,
    advancedQueries,
    vueEasyTree,
  },
  mixins: [ApiMixinTags, ApiMixinCable, fnMixin],
  data() {
    return {
      isAdvanceQuery: false,
      condition: {
        conditionalModels: [],
        classIdsType: '',
        classId: '',
      },
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      advancedQueriesProps: {
        dialogVisible: false,
        codeType: 'Tag',
      },
      // 显示列
      columnVisible: ['code', 'name', 'className', 'createdTime', 'lastModifiedTime'],
      columnVisibleOptions: [
        {
          value: 'code',
          label: 'Code',
        },
        {
          value: 'name',
          label: 'Name',
        },
        {
          value: 'className',
          label: 'category',
        },
        {
          value: 'parentName',
          label: 'ParentObject',
        },
        {
          value: 'flagName',
          label: 'state',
        },
        {
          value: 'longDescription',
          label: 'LongDescription',
        },
        {
          value: 'shortDescription',
          label: 'ShortDescription',
        },
        {
          value: 'createdTime',
          label: 'CreationTime',
        },
        // {
        //   value: 'createdUser',
        //   label: 'CreateAUser',
        // },
        {
          value: 'lastModifiedTime',
          label: 'LastModifiedTime',
        },
        // {
        //   value: 'lastModifiedUser',
        //   label: 'LastModifyTheUser',
        // },
      ],
      tagDynamicAttr: [], // 位号通用模板
      pickerOptions: {
        // 时间选择器禁止选之前的时间
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        },
      },
      activeNames: ['1'],
      uploadExcelDialog: false,
      uploadRulesDialog: false, // 选中属性规则的导入
      // 操作按钮列宽
      isPrStyle: false,
      tagListLoading: false, // 主表格加载状态
      relativeLoading: false, // 关联表格数据加载状态
      transferList: [
        { name: `${this.$t('NotHandedOver')}`, id: 2 },
        { name: `${this.$t('UnderReview')}`, id: 3 },
        { name: `${this.$t('HandedOver')}`, id: 0 },
      ],
      statusList: [
        { name: `${this.$t('TheModelIsAssociated')}`, id: true },
        { name: `${this.$t('ModelIsNotAssociated')}`, id: false },
      ],
      tagListTable: [], // 主表格数据列表
      isrecursion: false, // 是否递归
      // 主表格参数
      mainTableParam: {
        keyword: '',
        flag: '',
        isConnectedModel: '',
        pageno: 1,
        pagesize: 15,
        tagclassids: '',
        orderby: 'code',
        isasc: true,
      },
      searchTagClassIds: [], // 搜索位号类别
      totalCount: 0,
      tagListDialog: false, // 新增或编辑模态框显示与否
      handoverFormProps: {
        dialogVisible: false, // form弹框显示状态
        standardId: localStorage.getItem('standardId'),
        tabs: [
          // form弹框tab显示
          { name: '位号', label: '1' },
          // { name: '关联关系', label: '3' },
        ],
        rowData: null,
        isShowClassType: true,
      },
      tagListId: null, // 新增或编辑数据的id
      tagTreeData: [],
      treeLoading: false,
      idArray: [], // 批量导出的id集合
      tags: [], // 批量删除过滤后的id集合
      // 对象移交zh
      showTransferDialog: false,
      transferForm: {
        title: '',
        flowClass: `${this.$t('AssetHandoverProcess')}`,
        completedtime: '',
        processUserId: '',
        flowStatus: `${this.$t('NotHandedOver')}`,
        objectids: [],
      },
      activeName: 'first',
      transferTable: {
        tablePageNo: 1,
        tableTotal: 0,
      },
      // 目录树
      props: {
        label: 'name',
        children: 'nodes',
      },
      defaultPropsTree: {
        /* 位号树、文档树数据 */
        children: 'nodes',
        label: 'name',
      },
      isLoadTree: false,
      // 表单搜索部分
      tagTypeList: [], // 类别

      classOptionsProps: { value: 'id', label: 'lable' },
      // excel
      excelName: [
        `${this.$t('TagAssetTemplate')}`,
        `${this.$t('TagAssetImportResult')}`,
        `${this.$t('TheTagAssetExportFile')}`,
      ],
      exportLoading: false,
      downloadProgressVisible: false,
      downloadProgress: 0,
      totalSelection: [], // 存放跨页勾选的项
      transFerSelection: [], // 存放选中的未移交的项
      executorList: [], // 执行人下拉列表
      executorIds: [], // 执行人id集合
      handoverInfo: {}, // 存放下一步骤流程的信息
      // 移交弹窗表单的校验
      transferFormRules: {
        title: [{ required: true, message: `${this.$t('PleaseEnterATitle')}`, trigger: 'change' }],
        flowClass: [
          { required: true, message: `${this.$t('PleaseSelectAProcessType')}`, trigger: 'change' },
        ],
        completedtime: [
          { required: true, message: `${this.$t('PleaseSelectADeadline')}`, trigger: 'change' },
        ],
      },
      currentFlowId: '', // 当前流程id
      currentTree: [],
      classTreeProps: { label: 'name', children: 'children' },
      tagSearchName: '',
      tagSearchNameList: [],
      //  标准部分
      standardId: localStorage.getItem('standardId'),
      sortName: '', // 排序的字段
      sortType: '', // 排序的方式 asc为升序, desc为降序
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      tableHeader: [],
      isShowTreeMode: true,
      classKeyword: '',
      activeTab: 'category',
      hierarchyKeyword: '',
      hierarchyTreeData: [],
      currentHierarchyNodeId: '',
      hierarchyTreeProps: {
        label: 'name',
        children: 'childs',
        isLeaf: 'isLeaf',
      },
      isShowTooltip: false,
      qrCodeDialogVisible: false,
      qrCodeDialogTitle: '二维码样式设置',
      qrCodeSize: 10,
      showQrCodeSize: true,
      qrCodePercent: 0,
      qrCodeUrl: '',
      downloadLoading: false,
      conditionalModels: [], // 高级查询条件
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
    currentProject() {
      return this.$store.getters.currentProject || this.$store.getters['Sites/currentProject'] || {}
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  watch: {
    standardId(newVal) {
      if (newVal) {
        this.mainTableParam.tagclassids = ''
        this.tagSearchName = ''
        this.searchTagClassIds = []
        this.tagSearchNameList = []
        this.getDynamicTableHeaders()
        this.getDynamicTableResult('search')
        this.getParentTypeList()
      }
    },
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
      this.handoverFormProps.standardId = val
      this.idArray = []
      // this.getDynamicTableHeaders()
      // this.getDynamicTableResult()
    },
    classTreeMouseOver(node) {
      const offsetWidth = document.querySelector(`.${node}`).offsetWidth
      const clientWidth = document.querySelector(`.${node}`).parentNode.clientWidth
      if (offsetWidth <= clientWidth) {
        this.isShowTooltip = true
      } else {
        this.isShowTooltip = false
      }
    },
    // 收缩实体树
    changeTreeMode() {
      this.isShowTreeMode = !this.isShowTreeMode
    },
    // 高级查询弹框
    toMoreSearch() {
      this.advancedQueriesProps.dialogVisible = true
      this.advancedQueriesProps.standardId = this.standardId
      this.advancedQueriesProps.classIds = this.searchTagClassIds
    },
    // 高级查询保存
    updateAdvancedQueries(val) {
      console.log(val)
      this.advancedQueriesProps.dialogVisible = val.dialogVisible
      this.conditionalModels = val.conditionalModels
      if (!val.conditionalModels) return
      let classIdsType = ''
      this.searchTagClassIds.length === 1
        ? (classIdsType = 'singleClassId')
        : (classIdsType = 'multiClassId')
      this.getDynamicTableResult('search', val.conditionalModels, classIdsType, val.classId)
      this.isAdvanceQuery = true
      this.condition = {
        conditionalModels: val.conditionalModels,
        classIdsType,
        classId: val.classId,
      }
    },
    // 动态获取表头
    async getDynamicTableHeaders() {
      const res = await TagService.getDynamicTableHeaders({
        standardId: this.standardId,
        code: 'Tag',
      })
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
      } else {
        this.tableHeader = []
      }
    },
    searchList() {
      this.isAdvanceQuery = false
      this.getDynamicTableResult('search')
    },
    // 动态获取列表数据
    async getDynamicTableResult(type, conditionalModels, classIdsType, classId) {
      if (this.isAdvanceQuery) {
        conditionalModels = this.condition.conditionalModels
        classIdsType = this.condition.classIdsType
        classId = this.condition.classId
      }
      this.totalSelection = []
      if (type === 'search') this.mainTableParam.pageno = 1

      let res = null
      this.tagListLoading = true
      if (classIdsType && classIdsType === 'singleClassId') {
        // 选中单个类别
        res = await stdClassDataService.getDynamicTableData(
          {
            classId: this.searchTagClassIds[0],
            sorting: `${this.sortName} ${this.sortType}`,
            skipCount: (this.mainTableParam.pageno - 1) * this.mainTableParam.pagesize,
            maxResultCount: this.mainTableParam.pagesize,
            conditionalModels,
          },
          conditionalModels && conditionalModels.length > 0 ? 'query' : ''
        )
      } else {
        // 多类别或无类别
        if (_.isEmpty(this.searchTagClassIds)) {
          delete this.mainTableParam.tagclassids
        } else {
          this.mainTableParam.tagclassids = this.searchTagClassIds.join(',')
        }
        const params = {
          classId,
          standardId: this.standardId,
          skipCount: (this.mainTableParam.pageno - 1) * this.mainTableParam.pagesize,
          maxResultCount: this.mainTableParam.pagesize,
          sorting: `${this.sortName} ${this.sortType}`,
          cateCode: 'Tag',
          filter: this.mainTableParam.keyword,
          classIds: this.searchTagClassIds,
          conditionalModels,
        }
        if (this.activeTab === 'hierarchy') {
          params.tagId = this.currentHierarchyNodeId
        }
        if (this.activeTab === 'hierarchy' && this.hierarchyNodeId) {
          params.parentId = this.hierarchyNodeId
          p
          delete params.classIds
        } else if (this.activeTab === 'category') {
          params.classIds = this.searchTagClassIds
          delete params.parentId
        }
        res = await TagService.getDynamicTableResult(
          params,
          conditionalModels && conditionalModels.length > 0 ? 'query' : ''
        )
      }
      // this.tagListLoading = true
      // const res = await TagService.getDynamicTableResult(params)
      this.tagListLoading = false
      if (res && res.code === 0 && res.data) {
        this.tagListTable = res.data
        this.totalCount = res.totalCount
      } else {
        this.tagListTable = []
        this.totalCount = 0
      }
    },
    // 删除动态数据
    deleteDynamicData(rows) {
      if (rows.length > 0) {
        this.$confirm('是否确定要删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const params = []
          _.map(rows, (item) => {
            params.push({
              type: 2,
              standardId: this.standardId,
              dataId: item.id,
              classId: item.class_id ? item.class_id : null,
            })
          })
          const res = await DocumentManagementService.deleteDynamicData(params)
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.getDynamicTableResult('search')
          }
        })
      } else {
        this.$message.warning('请选择要删除的数据')
      }
    },
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await DocumentManagementService.downloadTemplate({
        standardId: this.standardId,
        cateCode: 'Tag',
        classIds: this.searchTagClassIds,
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '实体对象导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      formData.append('standardId', this.standardId)
      formData.append('cateCode', 'Tag')
      formData.append('classId', '')
      const res = await DocumentManagementService.importDynamicTableData(formData)
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '实体对象导入明细.xlsx',
          data: res,
        })
        this.getDynamicTableResult('search')
      }
      this.uploadFileProps.btnLoading = false
    },
    // 排序
    async sortChange(row) {
      let orderbytype = ''
      switch (row.order) {
        case 'ascending':
          orderbytype = 'asc'
          break
        case 'descending':
          orderbytype = 'desc'
          break
        default:
          orderbytype = ''
          break
      }
      this.sortName = row.prop
      this.sortType = orderbytype
      this.getDynamicTableResult()
    },
    // 列表转树
    listToTree(list) {
      // 先找出所有有效的父节点ID
      const parentIds = new Set(
        list.map((item) => {
          return item.id
        })
      )
      console.log(parentIds, 'parentIds')

      const result = list.reduce((prev, curr) => {
        curr.pathName = `/${curr.name}/`
        curr.children = list.filter((v) => {
          return v.parentId === curr.id
        })

        // 如果是根节点或找不到父节点,就放到第一级
        if (
          curr.parentId === '00000000-0000-0000-0000-000000000000' ||
          curr.parentId === '' ||
          curr.parentId === null ||
          !parentIds.has(curr.parentId)
        ) {
          prev.push(curr)
        }
        return prev
      }, [])

      return result
    },
    // 获取对象类别列表
    async getParentTypeList() {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1, // 已发布的实体
        info_type: 0, // 对象
        catecode: 'Tag', // 对象
        keyword: this.classKeyword,
      }
      this.treeLoading = true
      const res = await stdClassListService.getClassList(parameter)
      this.treeLoading = false
      if (res && res.code === 0 && res.data) {
        this.tagTreeData = res.data.length > 0 ? this.listToTree(res.data) : []
        // this.searchTagClassIds = this.tagTreeData.map((item) => {
        //   return item.id
        // })
        this.getDynamicTableResult('search')
      }
    },
    handleSearchTagTreeClick(node) {
      // 获取当前节点及其所有子节点的ID
      // eslint-disable-next-line no-shadow
      const getAllChildrenIds = (node) => {
        let ids = [node.id]
        if (node.children && node.children.length > 0) {
          node.children.forEach((child) => {
            ids = ids.concat(getAllChildrenIds(child))
          })
        }
        return ids
      }

      const nodeIds = getAllChildrenIds(node)
      this.searchTagClassIds = []
      if (!this.searchTagClassIds.includes(node.id)) {
        // 添加当前节点和所有子节点
        nodeIds.forEach((id) => {
          if (!this.searchTagClassIds.includes(id)) {
            this.searchTagClassIds.push(id)
          }
        })
      }
      this.isAdvanceQuery = false
      this.getDynamicTableResult('search')

      // if (!this.searchTagClassIds.includes(node.id)) {
      //   // 添加当前节点和所有子节点
      //   nodeIds.forEach((id) => {
      //     if (!this.searchTagClassIds.includes(id)) {
      //       this.searchTagClassIds.push(id)
      //       this.tagSearchNameList.push({
      //         name: node.name,
      //         id,
      //       })
      //     }
      //   })
      //   this.tagSearchName = node.name
      // } else {
      //   // 只移除当前节点，保持子节点选中状态
      //   const index = this.searchTagClassIds.findIndex((item) => {
      //     return item === node.id
      //   })
      //   if (index > -1) {
      //     this.searchTagClassIds.splice(index, 1)
      //     this.tagSearchNameList.splice(index, 1)
      //   }

      //   if (this.searchTagClassIds.length > 0) {
      //     const lastItem = this.tagSearchNameList[this.tagSearchNameList.length - 1]
      //     this.tagSearchName = lastItem.name
      //   } else {
      //     this.tagSearchName = null
      //   }
      // }
    },
    clearTagSearchTag() {
      this.searchTagClassIds = []
    },
    removeTagSearchTag() {
      this.searchTagClassIds = _.map(this.tagSearchNameList, (el) => {
        return el.id
      })
    },
    // 选择列表展示内容
    handleColumnVisibleChanged(val) {
      this.columnVisible = val
      this.$nextTick(() => {
        this.$refs.multipleTable.doLayout()
      })
    },
    // 初始化表格(type:1为点击搜索按钮触发请求，此时的pageNo一定为1)
    async initListTable(type) {
      this.totalSelection = []
      if (type === 'tree') {
        this.mainTableParam.pageno = 1
      }
      if (type === 'sizeChange') {
        this.mainTableParam.pageno = 1
      }
      if (type === 'search') {
        this.mainTableParam.pageno = 1
      }
      if (_.isEmpty(this.searchTagClassIds)) {
        delete this.mainTableParam.tagclassids
      } else {
        this.mainTableParam.tagclassids = this.searchTagClassIds.join(',')
      }
      this.tagListLoading = true
      let res = null
      const params = {
        StandardId: this.standardId,
        SkipCount: this.mainTableParam.pageno,
        MaxResultCount: this.mainTableParam.pagesize,
        Keyword: this.mainTableParam.keyword,
        Sorting: `${this.sortName} ${this.sortType}`,
        StdClassId: this.mainTableParam.tagclassids,
      }
      // if (this.showIsConnectedModel) {
      //   res = await DocumentManagementService.getTagIsConModelList(this.mainTableParam)
      // } else {
      // delete this.mainTableParam.isConnectedModel
      res = await DocumentManagementService.getTagList(params)
      // }
      if (res && res.data && res.code === 0) {
        this.tagListTable = res.data
        this.totalCount = res.totalCount
        _.forEach(this.tagListTable, (item) => {
          if (_.find(this.totalSelection, ['id', item.id])) {
            this.$nextTick(() => {
              this.$refs.multipleTable.toggleRowSelection(item, true)
            })
          }
        })
        this.tagDynamicAttr = res.data.attributeTableSimpleDictionary
        this.columnVisibleOptions = _.differenceBy(
          this.columnVisibleOptions,
          _.map(this.tagDynamicAttr, (item) => {
            return {
              value: item.fieldName,
              label: item.displayName,
            }
          }),
          'label'
        )
        this.columnVisibleOptions = _.concat(
          this.columnVisibleOptions,
          _.map(this.tagDynamicAttr, (item) => {
            return {
              value: item.fieldName,
              label: item.displayName,
            }
          })
        )
        if (!this.workBenchStatusVisible) {
          // 没有移交流程
          this.columnVisibleOptions = _.filter(this.columnVisibleOptions, (item) => {
            return item.value !== 'flagName'
          })
        }
      } else {
        // this.$message.error(res.msg)
        this.tagListTable = []
        this.totalCount = 0
      }
      this.tagListLoading = false
      this.$nextTick(() => {
        this.$refs.multipleTable.doLayout()
      })
    },
    // 获取多选框选中的id数组
    getIdArray(val) {
      _.forEach(this.totalSelection, (item) => {
        if (_.find(this.tagListTable, ['id', item.id])) {
          // 选中的列表中有存在项在当前表格中(val:注意每次返回的是当前页的选择项数组)
          this.totalSelection = _.difference(this.totalSelection, [item]) // 清空当前表格中已经选中的所有想
        }
      })
      this.totalSelection = [...this.totalSelection, ...val] // 先清空当前页的选择项在组合
      // 获取id数组集合
      this.idArray = _.map(this.totalSelection, 'id')
      this.tags = _.map(
        _.filter(this.totalSelection, (item) => {
          return item.flag === 2 || !this.workBenchStatusVisible
        }),
        'id'
      )
    },
    // 打开新增或编辑模态框
    async openTagListDialog(row) {
      if (row) this.tagListId = row.id
      this.handoverFormProps.rowData = row
      this.handoverFormProps.dialogVisible = true
      if (row) {
        this.handoverFormProps.tabs = [
          { name: '位号', label: '1' },
          { name: '关联关系', label: '3' },
        ]
        this.handoverFormProps.type = 'edit'
      } else {
        this.handoverFormProps.tabs = [{ name: '位号', label: '1' }]
        this.handoverFormProps.type = 'add'
        this.handoverFormProps.classId = this.searchTagClassIds?.[0] || ''
      }
    },
    // 新增弹框子组件传参
    handoverFormEmit(val) {
      if (val) {
        this.handoverFormProps.dialogVisible = val.dialogVisible
        this.getDynamicTableResult()
      }
    },
    // 跳转到位号对象浏览
    linkTagContent(row) {
      // return this.$router.push(`content/${id}`)
      localforage.setItem('tagId', row.id).then(() => {
        this.$router.push({
          path: `${this.basePath}/legacy-resource/data-asset-management/asset-view`,
          query: {
            id: row.id,
            classId: row.class_id,
          },
        })
      })
    },
    // 文件导出
    exportExcel() {
      this.$confirm('可能需要等待时间较长，请确认是否要继续', `${this.$t('hint')}?`, {
        confirmButtonText: `${this.$t('Sure')}`,
        cancelButtonText: `${this.$t('Cancel')}`,
        type: 'warning',
      }).then(() => {
        this.exportDynamicTableData()
      })
    },
    // 动态表格导出数据
    async exportDynamicTableData() {
      this.exportLoading = true
      const res = await DocumentManagementService.exportDynamicTableData({
        standardId: this.standardId,
        cateCode: 'Tag',
        classIds: this.searchTagClassIds,
        ids: this.idArray,
        keywords: this.mainTableParam.keyword,
      })
      this.exportLoading = false
      if (res) {
        this.downLoadExcel('实体对象导出结果.xlsx', res)
      }
    },
    // tab切换事件处理
    handleTabChange(tab) {
      if (tab.name === 'category') {
        this.getParentTypeList()
      } else if (tab.name === 'hierarchy') {
        this.getHierarchyList()
      }
    },
    // 获取上下级列表数据
    async getHierarchyList() {
      const params = {
        standardId: this.standardId,
        tagType: 1,
        filter: this.hierarchyKeyword,
      }
      this.treeLoading = true
      const res = await TagService.getTagTreeList(params)
      this.treeLoading = false
      if (res && res.code === 0 && res.data) {
        this.hierarchyTreeData = res.data
      }
    },
    // 懒加载节点数据
    async loadHierarchyNode(node, resolve) {
      // 根节点直接返回已加载的数据
      if (node.level === 0) {
        resolve(this.hierarchyTreeData)
        return
      }

      try {
        const res = await TagService.getTagTreeListChildren({
          standardId: this.standardId,
          tagType: 1,
          filter: this.hierarchyKeyword,
          code: node.data.code,
        })
        resolve(res?.code === 0 && res?.data ? res.data : [])
      } catch (error) {
        console.error('加载节点失败:', error)
        resolve([])
      }
    },
    // 处理上下级树点击事件
    handleHierarchyTreeClick(node) {
      console.log(node, '上下级 node')
      this.isAdvanceQuery = false
      this.currentHierarchyNodeId = node.id
      this.getDynamicTableResult('search')
    },
    // 下载二维码
    toDownloadQrCode() {
      this.qrCodeDialogTitle = '二维码样式设置'
      if (!this.idArray.length) {
        this.$confirm('全部编码生成时间较长，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          this.qrCodeDialogVisible = true
          this.showQrCodeSize = true
        })
      } else {
        this.qrCodeDialogVisible = true
        this.showQrCodeSize = true
      }
    },
    // 二维码样式设置确认
    async qrCodeSubmit() {
      this.showQrCodeSize = false
      this.qrCodeDialogTitle = '二维码下载'
      this.qrCodePercent = 0
      const params = {
        standardId: this.standardId,
        cateCode: 'Tag',
        filter: this.mainTableParam.keyword,
        classIds: this.searchTagClassIds,
        ids: this.idArray,
        conditionalModels: this.conditionalModels,
        parentId: this.hierarchyNodeId,
        size: this.qrCodeSize,
        taskId: '',
      }
      const key = await TagService.generateBulkQrcodes(params)
      if (key) {
        // 每隔1秒请求一次redis进度
        const timer = setInterval(async () => {
          const res = await TagService.getRedisProgress(key)
          this.qrCodePercent = Math.floor(res.currentProgress)
          if (res.isCompleted) {
            this.qrCodePercent = 100
            this.qrCodeUrl = res.data
            clearInterval(timer)
          }
        }, 1000)
      }
    },
    // 下载二维码文件
    async downloadQrCode() {
      this.downloadLoading = true
      const res = await TagService.getLoacleFile(this.qrCodeUrl)
      this.downloadLoading = false
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '二维码.zip',
          data: res,
        })
      }
    },
    // 关闭二维码样式设置弹框
    closeQrCodeDialog() {
      this.qrCodeDialogVisible = false
    },
  },
  async created() {
    // 判断是否切换项目
    const oldTenantId = localStorage.getItem('oldTenantId')
    const newTenantId = localStorage.getItem('TenantId')
    this.standardId = localStorage.getItem('standardId')
    if (this.standardId && oldTenantId === newTenantId) {
      await this.getParentTypeList()
      this.getDynamicTableHeaders()
      this.getDynamicTableResult()
    }
  },
  async activated() {
    // this.standardId = localStorage.getItem('standardId')
  },
}
</script>
<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>

#tagList /deep/ .el-select__tags-text {
  display: inline-block;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#tagList /deep/ .el-tag__close {
  top: 0px;
}
/deep/.el-card__body {
  height: calc(100% - 40px);
  padding: 0px;
}
.handoverDialog {
  /deep/.el-tabs__content {
    height: 364px;
    overflow-y: scroll;
  }
}
/deep/.el-table--border th.gutter:last-of-type {
  display: block !important;
  width: 10px !important;
  white-space: nowrap;
}
// /deep/.el-table__fixed,
// /deep/.el-table__fixed-right {
//   background-color: #f9f9f9;
//   height: auto !important;
//   bottom: 10px !important;
// }
/deep/.el-table__fixed-body-wrapper,
/deep/.el-table__body {
  padding-bottom: 10px !important; // 滚动条高度
}
/deep/ .el-table__body-wrapper {
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 3px;
    height: 10px;
  }
}
.text-color-red {
  color: #f5222d;
}
.text-color-green {
  color: #52c41a;
}
.attrRules-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
}
/deep/.el-tabs__content {
  padding: 0 10px;
}
.tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.text-blue {
  color: #409eff;
}
.font-bold {
  font-weight: bold;
}
.icon-bg-circleLeft:before,
.icon-bg-circleRight:before {
  color: var(--buttonPrimaryBg);
}

.class-tree-tabs {
  /deep/ .el-tabs__nav-wrap::after {
    display: none;
  }

  /deep/ .el-tabs__nav {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  /deep/ .el-tabs__item {
    flex: 1;
    text-align: center;
    max-width: 200px;
  }

  /deep/ .el-tabs__nav-wrap {
    padding: 0 20%;
  }
  /deep/ .el-tabs__content {
    height: 100%;
  }
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
<style>

.template-attr-tab .el-tabs__content {
  height: 276px !important;
  overflow-y: auto;
}
.el-popper.tag_select-popper .el-select-dropdown__item {
  height: 100% !important;
  padding: 0;
}

</style>
